"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _table = _interopRequireDefault(require("../style/table"));

var _mergeTheme = _interopRequireDefault(require("../../style/mergeTheme"));

var Table = function Table(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      style = _ref.style,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["children", "theme", "style"]);
  var memoTheme = (0, _react.useMemo)(function () {
    return (0, _mergeTheme["default"])(theme.table, style);
  }, [style]);
  return _react["default"].createElement(_table["default"], (0, _extends2["default"])({
    theme: memoTheme
  }, rest), children);
};

Table.propTypes = {
  style: _propTypes["default"].object,

  /**
   * Basic style
   */
  theme: _propTypes["default"].shape({
    /**
     * @description td shape
     */
    td: _propTypes["default"].shape({
      /**
       * @default 0 none
       */
      borderTop: _propTypes["default"].string,

      /**
       * @description без прозрачности, потому что хром некорректно делает border-collapse и рамки налазят друг на друга из-за чего меняют цвет
       * @default 1px solid ${color(palette.elDivider).rgb()}
       */
      borderBottom: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderLeft: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderRight: _propTypes["default"].string,

      /**
       * @default palette.tsSmall
       */
      fontSize: _propTypes["default"].string,

      /**
       * @default palette.tlSmall
       */
      lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default left
       */
      textAlign: _propTypes["default"].string,

      /**
       * @default middle
       */
      verticalAlign: _propTypes["default"].string,

      /**
       * @default border-box
       */
      boxSizing: _propTypes["default"].string,

      /**
       * @default palette.tFilled
       */
      color: _propTypes["default"].string,

      /**
       * @default transparent
       */
      background: _propTypes["default"].string,

      /**
       * @default palette.gutter + 'px'
       */
      paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      paddingBottom: _propTypes["default"].string,

      /**
       * @default palette.gutter + 'px'
       */
      paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default 60px
       */
      height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    }),

    /**
     * @description th shape
     */
    th: _propTypes["default"].shape({
      /**
       * @default 0 none
       */
      borderTop: _propTypes["default"].string,

      /**
       * @description без прозрачности, потому что хром некорректно делает border-collapse и рамки налазят друг на друга из-за чего меняют цвет
       * @default 0 none
       */
      borderBottom: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderLeft: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderRight: _propTypes["default"].string,

      /**
       * @default palette.tsXSmall
       */
      fontSize: _propTypes["default"].string,

      /**
       * @default palette.tlXSmall
       */
      lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default left
       */
      textAlign: _propTypes["default"].string,

      /**
       * @default middle
       */
      verticalAlign: _propTypes["default"].string,

      /**
       * @default border-box
       */
      boxSizing: _propTypes["default"].string,

      /**
       * @default palette.tInactive
       */
      color: _propTypes["default"].string,

      /**
       * @default palette.elPrimaryLight
       */
      background: _propTypes["default"].string,

      /**
       * @default palette.gutter + 'px'
       */
      paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      paddingBottom: _propTypes["default"].string,

      /**
       * @default palette.gutter + 'px'
       */
      paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.twSemi
       */
      fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    }),

    /**
     * @description tr shape
     */
    tr: _propTypes["default"].shape({
      /**
       * @default transparent
       */
      background: _propTypes["default"].string,

      /**
       * @default pointer
       */
      hoverCursor: _propTypes["default"].string,

      /**
       * @default palette.elPrimaryLight
       */
      hoverBackground: _propTypes["default"].string
    }),

    /**
     * @description tbh shape
     */
    tbh: _propTypes["default"].shape({
      /**
       * @default 0 none
       */
      borderTop: _propTypes["default"].string,

      /**
       * @description без прозрачности, потому что хром некорректно делает border-collapse и рамки налазят друг на друга из-за чего меняют цвет
       * @default 1px solid ${color(palette.elDivider).rgb()}
       */
      borderBottom: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderLeft: _propTypes["default"].string,

      /**
       * @default 0 none
       */
      borderRight: _propTypes["default"].string,

      /**
       * @default palette.tsXSmall
       */
      fontSize: _propTypes["default"].string,

      /**
       * @default palette.tlXSmall
       */
      lineHeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default left
       */
      textAlign: _propTypes["default"].string,

      /**
       * @default middle
       */
      verticalAlign: _propTypes["default"].string,

      /**
       * @default border-box
       */
      boxSizing: _propTypes["default"].string,

      /**
       * @default palette.tInactive
       */
      color: _propTypes["default"].string,

      /**
       * @default ${palette.gutter / 2}px
       */
      paddingTop: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default ${palette.gutter / 2}px
       */
      paddingBottom: _propTypes["default"].string,

      /**
       * @default palette.gutter + 'px'
       */
      paddingLeft: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.gutter + 'px'
       */
      paddingRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default palette.twNormal
       */
      fontWeight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    }),

    /**
     * @description table shape
     */
    table: _propTypes["default"].shape({
      /**
       * @default separate
       */
      borderCollapse: _propTypes["default"].string,

      /**
       * @default 0
       */
      borderSpacing: _propTypes["default"].number,

      /**
       * @default 100%
       */
      width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

      /**
       * @default auto
       */
      minWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
    })
  }),
  children: _propTypes["default"].any
};
var _default = Table;
exports["default"] = _default;